import React, {Component} from "react";
import {setUserActive, setUserAuth, setUserData, setUserDebts, setUserToken} from "../../store/user/actions";
import {setTapBarData} from "../../store/tapBar/actions";
import {setBankTransferType, setCardTransferData} from "../../store/transfer/actions";
import {connect} from "react-redux";
import {withRouter} from "@happysanta/router";
import {Div} from "@vkontakte/vkui";
import axios from "../../axios/axios";
import SkillItem from "./SkillItem";
import {SERVER_CONFIG} from "../../config";


class SkillList extends Component {

    state = {
        skillList: []
    }



    render() {
        const skillList = this.state.skillList
        return (
            skillList.map((item, key) => {
                return (<SkillItem item={item} key={key}/>)
            })
        )
    }

    componentDidMount() {
      axios.get('skill')
            .then(res => res.data)
            .then(res => this.setState({skillList: res}))

    }
}

const mapStateToProps = (state) => {
        return {
            user: state.user,
            tapBar: state.tapBar,
            transfer: state.transfer
        };
    }
;

const mapDispatchToProps =
    {
        setUserData,
        setUserAuth,
        setUserToken,
        setUserActive,
        setUserDebts,
        setTapBarData,
        setCardTransferData,
        setBankTransferType
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SkillList));